import styled from 'styled-components';

const NavContainer = styled.div`
  padding: 0 20px 0 20px;
  height: 60px;
  background-color: #1d1d1d;
`;

export default NavContainer;
